import { render, staticRenderFns } from "./manhua.vue?vue&type=template&id=7b2b8a3a&scoped=true"
import script from "./manhua.vue?vue&type=script&lang=js"
export * from "./manhua.vue?vue&type=script&lang=js"
import style0 from "./manhua.vue?vue&type=style&index=0&id=7b2b8a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b8a3a",
  null
  
)

export default component.exports